import YearService from '@/services/year.services'
export const namespaced = true

export const actions = {
  fetchYear(context, payload) {
    let params = 'params' in payload ? payload.params : null
    return YearService.getYear(payload.jwt, params)
  },
  addYear(context, payload) {
    return YearService.postYear(payload.jwt, payload.body)
  },
  editYear(context, payload) {
    return YearService.putYear(payload.jwt, payload.body, payload.id)
  },
  deleteYear(context, payload) {
    return YearService.deleteYear(payload.jwt, payload.body, payload.id)
  },
}
